import PropTypes from 'prop-types';
import React from 'react';
import './SuggestAnswerButton.scss';

const SuggestAnswerButton = (props) => {
  return (
    <div className="Suggest-Answer-Button">
      <span>{props.name}</span>
    </div>
  );
};

SuggestAnswerButton.propTypes = {
  name: PropTypes.string,
};

export default SuggestAnswerButton;
